module.exports = __webpack_public_path__ + "static/img/007.23ad983e.png";